export default {
  en: {
    headers: {
      pageTitle: "{supplierName}'s documents",
      headerTitle: 'Documents',
    },
    uploader: {
      title: 'Add a new document',
      description: 'Drag and drop, or select a file',
      button: 'Upload new',
      upload: 'Upload',
      select: 'Select existing',
      attach: 'Attach evidence',
      suggestionsAvailable: 'Suggestions available',
    },
    answers: {
      docEvidence: 'Document evidence',
      removeDoc: 'Remove document',
      retry: 'Retry upload',
    },
    preview: {
      download: 'Download',
      rename: 'Rename',
      history: 'History',
      replace: 'Replace',
      delete: 'Delete',
      deleteModalTitle: 'Delete document "{name}"?',
      deleteModalDescription:
        "Please confirm if you would like to delete '{name}'. It will also be removed from all answers it is currently attached to.",
      retry: 'Retry',
      setPrivate: 'Hide from clients',
      setPublic: 'Make visible to clients',
      remove: 'Remove',
    },
    previewSidePanel: {
      info: 'Info',
      history: 'History',
      comments: 'Comments',
      about: 'About',
      document: 'Document',
      fileSize: 'File size',
      fileType: 'File type',
      attachments: 'Attachments ({count})',
      documentHistory: 'Document history',
    },
    attachments: {
      control: 'Control {controlCode}',
      threatQuestion: '{threatName} Q.{questionNumber}',
      emergingThreat: 'Emerging Threat',
    },
    renameModal: {
      title: 'Rename document "{name}"?',
      newName: 'New document name',
      newNameRequired: 'Enter a new name for the document',
      oldName: 'Original document name',
    },
    scanStatus: {
      scanning: 'Processing file',
      rejected: 'Failed to process file, contact support for help',
    },
    attachModal: {
      title: 'Select a document',
      close: 'Close',
      save: 'Save changes',
      searchPlaceholder: 'Search documents',
      emptySearchTitle: 'No documents',
      emptySearchSubtitle: 'No documents currently match your search',
      suggested: 'Suggested',
      deselect: 'Deselect',
    },
    suggested: {
      suggestedDocuments: 'Suggested documents',
      latestDocuments: 'Latest documents',
    },
    history: {
      title: 'Version history',
      types: {
        document_replaced: 'Document replaced',
        document_renamed: 'Document renamed',
        document_created: 'Document created',
        attachment_created: 'Document attached',
        attachment_removed: 'Document detached',
        document_set_private: 'Document marked not visible for clients',
        document_set_not_private: 'Document marked as visible to clients',
      },
      byName: 'by {name}',
    },
    attachedOn: 'Attached on:',
    placeholder: {
      title: 'There are no documents.',
      description: 'Your organisation currently has no documents to display.',
    },
    setPrivateStatusModal: {
      title: 'Set document visibility',
      descriptionPrivate:
        'Please confirm if you would like to make the document "{documentName}" not visible to clients.',
      descriptionNotPrivate:
        'Please confirm if you would like to make the document "{documentName}" visible to clients.',
      makePrivate: 'Make not visible to clients',
      makeNotPrivate: 'Make visible to clients',
      failed: 'Failed to update document visibility',
      cantSetPrivate:
        'This document cannot be made hidden to clients as it is attached to one or more answers. Remove all the attachments before trying again.',
    },
    tooltips: {
      private: 'This document is not visible to clients',
    },
  },
};
